export default class PasswordUtils {

  static getRegexPattern() {
    return "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[~!@#$%^&*()_+=-])([A-Za-z\\d~!@#$%^&*()_+=-]){15,20}$";
  }
}